"use strict";

function getWishlistItems() {
  try {
    const items = JSON.parse(localStorage.getItem("glozin__wishlist-items"));
    return Array.isArray(items)
      ? [...new Set(items.map((item) => String(item)).filter(Boolean))]
      : [];
  } catch (e) {
    return [];
  }
}

function setWishlistItems(items) {
  const wishlistItems = [
    ...new Set(items.map((item) => String(item)).filter(Boolean)),
  ];
  localStorage.setItem("glozin__wishlist-items", JSON.stringify(wishlistItems));
  return wishlistItems;
}

const wishlistDiv = document.querySelector(".wishlist-page-main");
var WishlistPageShopify = (function () {
  return {
    initWishlistItems: function () {
      if (window.location.search.indexOf("page=") == -1) {
        this.init();
      }
    },

    init: function () {
      const _this = this;
      const wishlistItems = setWishlistItems(getWishlistItems());
      if (wishlistDiv) {
        const div_no_product = wishlistDiv.querySelector(
          ".wishlist-no-product-js"
        );
        if (wishlistItems.length === 0) {
          _this.skeletonFunction(0);
          div_no_product.classList.remove("hidden");
          wishlistHeader.init();
        } else {
          const query = wishlistItems
            .map((item) => (/^\d+$/.test(item) ? `id:${item}` : `handle:${item}`))
            .join(" OR ");
          const section_id = document.querySelector(".wishlist-page-section")
            .dataset.sectionId;
          var productAjaxURL =
            "?section_id=" +
            section_id +
            "&view=wishlist" +
            "&type=product&options[unavailable_products]=last&q=" +
            encodeURIComponent(query);

          fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then((response) => response.text())
            .then((responseText) => {
              const htmlParser =
                typeof parser !== "undefined" ? parser : new DOMParser();
              const html = htmlParser.parseFromString(responseText, "text/html");
              const exist_row = wishlistDiv.querySelector(
                ".wishlist-list-items"
              );
              if (exist_row) {
                exist_row.remove();
              }
              const er = html.querySelector(
                ".wishlist-page-main .wishlist-list-items"
              );
              const productCards = er
                ? er.querySelectorAll("button-wishlist").length
                : 0;
              if (productCards > 0) {
                wishlistDiv.innerHTML = html.querySelector(
                  ".wishlist-page-main"
                ).innerHTML;
                _this.skeletonFunction(700);
              } else {
                setWishlistItems([]);
                wishlistHeader.init();
                _this.skeletonFunction(0);
                div_no_product.classList.remove("hidden");
              }
              _this.mergeItems();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally((e) => {
              initLazyloadItem();
            });
        }
      }
    },
    mergeItems: function () {
      const arr = [];
      if (wishlistDiv) {
        wishlistDiv.querySelectorAll("button-wishlist").forEach((e) => {
          const wishlistKey = e?.dataset.productHandle || e?.dataset.productId;
          if (wishlistKey) {
            arr.push(wishlistKey);
          }
        });
      }
      setWishlistItems(arr);
      wishlistHeader.init();
    },
    skeletonFunction: function (timer) {
      window.setTimeout(function () {
        if (this.document.querySelector("skeleton-page")) {
          this.document.querySelector("skeleton-page").remove();
        }
        if (this.document.querySelector(".wishlist-page-section-inner")) {
          this.document
            .querySelector(".wishlist-page-section-inner")
            .classList.remove("hidden");
        }
      }, timer);
    },
  };
})();
WishlistPageShopify.initWishlistItems();
